<template>
    <div id="app">

        <iframe MARGINWIDTH=0
                MARGINHEIGHT=0
                HSPACE=0
                VSPACE=0
                FRAMEBORDER=0
                SCROLLING=no
                :src="system.headUrl"
                width="100%"
                height="130px"
                class="header-iframe"
                v-if="!hideFrame"></iframe>

        <router-view></router-view>

        <iframe MARGINWIDTH=0
                MARGINHEIGHT=0
                HSPACE=0
                VSPACE=0
                FRAMEBORDER=0
                SCROLLING=no
                :src="system.footUrl"
                width="100%"
                height="120px"
                class="footer-iframe"
                v-if="!hideFrame"></iframe>

        <!-- IE控件 -->
        <p align="center"
           v-if="Utils.isIE()"
           hidden>
            <OBJECT ID="SafeEngineCtl"
                    CLASSID="CLSID:B48B9648-E9F0-48A3-90A5-8C588CE0898F"
                    border=0></OBJECT>

            <OBJECT ID="SESealCtrl"
                    CLASSID="CLSID:1A17A19B-3751-45A0-A8BC-2E87B0D2B50C"
                    border=0></OBJECT>
        </p>

        <notice-dialog v-if="loginTime === 0"
                       :visible.sync="showGuideDialog"></notice-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NoticeDialog from './components/notice-dialog.vue';
import { keyType, keyUsage } from './components/ukey/keyModel';
import Ukey from "./components/ukey/Ukey";

export default {
    name: 'app',
    components: { NoticeDialog },
    data () {
        return {
            ukey: '',
            timer: 0,
            registerNoTimer: 0,
            cert: '',
            sealData: '',
            picData: '',
            isOld: false,
            intervalTimer: 0,
            showGuideDialog: true,
            showLogoutDialog: true,
            sm2Cert: '',

            loopTimer: 0,
        };
    },
    provide () {
        return {
            app: this
        };
    },
    computed: {
        // 签署来源
        ...mapGetters(['isEtl', 'isLP', 'system']),
        signSource () {
            return this.$route.query.signSource;
        },
        hideFrame () {
            return this.signSource == 'ZWDT_OPEN' || this.$route.meta.hideFrame || this.$route.query.hideFrame && this.$route.query.hideFrame !== 'false';
        },
        currUser () {
            return this.$store.getters.quser && this.$store.getters.quser.user || null;
        },
        isPersonal () {
            return this.$store.getters.isPersonal;
        },
        isCompany () {
            return !this.isPersonal;
        },
        // 登录次数
        loginTime () {
            return this.currUser && this.currUser.loginNum;
        },
        // 统一社会信用代码
        getRegisterNo () {
            return this.$store.state.registerNo;
        },
        ukeyInit() {
            return this.ukey.init;
        },
        ukeyLinked() {
            return this.ukeyInit && this.cert;
        },
    },
    watch: {
        'cert': {
            handler (nv) {
                nv && this.isCompany && this.$store.dispatch('getRegisterNo', nv);
            },
            immediate: true
        },
        getRegisterNo: {
            handler (nv) {
                nv && this.checkRegisterNo(nv);
            },
            immediate: true
        },
    },

    async created() {
        if (this.$route.meta.loginAuth) return;

        await this.$store.dispatch('initSystemConfig');

        this.$nextTick(() => {
            if(this.$store.state.system.alertMessage) {
              this.$alert(this.$store.state.system.alertMessage, '温馨提示')
            }
        })

        if (!this.signSource) {
            await this.$store.dispatch('initQuser');
        }
    },

    mounted () {
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        if (this.$route.meta.loginAuth) {
            return;
        }

        //网页加载完毕之后启动一次服务，启动成功之后获取ukey信息
        // if (window.attachEvent) {
        //     window.attachEvent('onload', this.handlerBorwser);
        // } else {
        //     console.log('addEventListener');
        //     window.addEventListener('load', this.handlerBorwser);
        // }
        this.handlerBorwser();
    },
    methods: {
        // window.loaded 时执行 handlerBorwser
        handlerBorwser () {
            console.log('handlerBorwser');
            if (!this.Utils.isIE()) {
                console.log('begin init chrome ukey');
                this.ukey = new Ukey();
                // this.startService();
            } else {
                this.ukey = new Ukey(window.SafeEngineCtl, window.SESealCtrl);
                // this.getSafeEngineInfo('', false);
            }

            // loop
            this.loopTimer = setInterval(() => {
                if (this.ukeyLinked) {
                    clearInterval(this.loopTimer);
                    return;
                }

                if (!this.Utils.isIE()) {
                    this.startService();
                } else {
                    this.getSafeEngineInfo('', false);
                }
            }, 5000);

        },

        async getSafeEngineInfo (pin, needPass) {
            try {
                await this.ukey.initService(pin, needPass);
                let cert = await this.ukey.getCert();
                this.cert = encodeURIComponent(cert.result);
                let picData = await this.ukey.getSeal(2);
                this.picData = encodeURIComponent(picData.result);
                let sealData = await this.ukey.getSeal(1);
                this.isOld = sealData.result !== "MII=";
                this.sealData = this.isOld ? encodeURIComponent(sealData.result) : encodeURIComponent(picData.result);

                // sm2
                // await this.ukey.initSm2Service(pin, needPass);
                // let sm2Cert = await this.ukey.getCert(keyType.K_SHCA_ASYMID_SM2, keyUsage.K_SHCA_USAGE_SIGN);
                // this.sm2Cert = encodeURIComponent(sm2Cert.result);
            } catch (error) {
                console.log(this.cert);
                console.log(this.picData);
                console.log(JSON.stringify(error));
            }
        },

        /**
        * 检测公司注册码是否为18位
        */
        async checkRegisterNo (code) {
            if (code.length < 18) {
                this.$alert('您的数字证书内没有统一社会信用代码信息，请尽快至就近的数字证书服务网点进行数字证书信息的更新', '更新证书', { type: 'warning' });
                this.registerNoTimer = setInterval(() => {
                    this.$alert('您的数字证书内没有统一社会信用代码信息，请尽快至就近的数字证书服务网点进行数字证书信息的更新', '更新证书', { type: 'warning' });
                }, 60000);
            }
        },

        // 启动服务
        initService () {
            this.ukey
                .startService(keyType.K_SHCA_ASYMID_RSA)
                .then(() => {
                    console.log('get ukey info');
                    this.getUkeyInfo();
                    clearInterval(this.intervalTimer);
                }).catch((e) => {
                    console.log('catch error info', e);
                    this.initUkeyInfo();
                    // 拔出Ukey时Ukey登录的用户退出登录
                    // !this.isEtl && this.isLP && this.logout();
                    clearInterval(this.intervalTimer);
                });
        },
        // 退出登录
        async logout() {
            await this.axios({
                url: '/logout',
                method: 'GET',
            });
            this.$message('Ukey已拔出！');
            location.replace('/login');
        },

        // 启动服务
        startService () {
            this.initUkeyInfo();
            this.initService();
            clearInterval(this.intervalTimer);
            this.intervalTimer = setInterval(() => {
                this.initService();
            }, 5000);
        },

        // 获取ukey信息
        async getUkeyInfo () {
            try {
                this.ukey.getCert(keyType.K_SHCA_ASYMID_RSA, keyUsage.K_SHCA_USAGE_SIGN).then((data) => {
                    if (data.code == 0) {
                        this.cert = encodeURIComponent(data.result);
                        return this.ukey.getSeal(1);
                    }
                }).then((data) => {
                    if (data.code == 0) {
                        this.isOld = data.result !== 'MII=';
                        if (this.isOld) {
                            this.sealData = encodeURIComponent(data.result);
                        }
                        return this.ukey.getSeal(2);
                    }
                }).then((data) => {
                    if (data.code == 0) {
                        if (!this.isOld) {
                            this.sealData = encodeURIComponent(data.result);
                        }
                        this.picData = encodeURIComponent(data.result);
                        return this.ukey.getCert(keyType.K_SHCA_ASYMID_SM2, keyUsage.K_SHCA_USAGE_SIGN);
                    }
                }).then((data) => {
                    if (data.code === 0) {
                        this.sm2Cert = encodeURIComponent(data.result);
                    }
                });
            } catch (err) {
                // 如果code不等于0 且UKEY无印章，则判断为老版本UKEY
                if (this.cert && (!this.sealData || !this.picData)) {
                    this.isOld = true;
                }
                // 没有设备
                if (err && err.code == '2181300305') {
                    this.initUkeyInfo();
                }
            }
        },

        initUkeyInfo () {
            this.cert = '';
            this.picData = '';
            this.sealData = '';
        },

        // 轮询获取设备列表
        handleUkeyDevice () {
            this.timer = setInterval(() => {
                this.getUkeyDevice();
            }, 10000);
        },

        // 判断是否能获取设备，如果能，则开始获取ukey信息
        getUkeyDevice () {
            this.ukey.listPlugin(1).then((data) => {
                if (!data.result) {
                    this.cert = '';
                } else {
                    !this.cert && this.getUkeyInfo();
                }
            }).catch(() => {
                this.cert = '';
            });
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
        clearInterval(this.registerNoTimer);
    }
};
</script>

<style lang="less">
@import url("./assets/css/index.less");

#app {
    font-family: "Avenir";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    overflow: auto;
    font-size: 14px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
